import { Suspense, useEffect, useState } from "react";
import { Notifications } from 'react-push-notification';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Main from "./Components/Main/Main";
import ConfigurationServices from "./Services/Configuration/ConfigurationServices";
import Backdroper from "./Utils/Loading/Loading";
import "./index.scss";

const App = () => {
  const [isBusy, setBusy] = useState(true);
  useEffect(() => {
    let minutes = 0;
    if (!!localStorage.getItem("expirationDate")) {
      let expireDate: any = localStorage.getItem("expirationDate")?.split('_')
      let today: any = new Date();
      let time = expireDate[1].split('-');
      let times = time[0] + ':' + time[1];
      let expire: any = new Date(expireDate[0] + ' ' + times);
      var diff = expire - today;
      minutes = Math.floor((diff / 1000) / 60);
    }
    if (minutes < 10) {
      ConfigurationServices.GetBaseToken((res => {
        setBusy(false);
      }));
    } else {
      setBusy(false);
    }
  }, [])
  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        closeButton={false}
        theme="colored"
      />
      <Notifications />
      {isBusy ? ''
        :
        < Suspense fallback={<Backdroper />}>
          <BrowserRouter>
            <Switch>
              <Route path={"/"} key={1} component={Main} />
            </Switch>
          </BrowserRouter>
        </Suspense >
      }
    </>
  );
};

export default App;
